import script from "./Webhook.vue?vue&type=script&setup=true&lang=ts"
export * from "./Webhook.vue?vue&type=script&setup=true&lang=ts"

import "./Webhook.vue?vue&type=style&index=0&id=c3c4e60a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c4e60a"]])

export default __exports__